export default __webpack_public_path__ + "static/273-0607d914519479ada28001c2db55782f.gif";